var BreadcrumbDataTestId = /* @__PURE__ */ ((BreadcrumbDataTestId2) => {
  BreadcrumbDataTestId2["BREADCRUMB_CONTAINER"] = "breadcrumb";
  return BreadcrumbDataTestId2;
})(BreadcrumbDataTestId || {});
export {
  BreadcrumbDataTestId
};
